import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { PersonAvatar } from '@factorialco/factorial-one-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

interface Props {
  employeeId: string
  employeeName: string
  attachment: string
}

const EmployeeListItem = ({ employeeId, employeeName, attachment }: Props) => {
  const { navigation } = useNavigation()

  const goToEmployee = (id: string): string => {
    track(trackingEvents.training.trainingRequest.participantDetail)

    return navigation.employees.id.fullPath({ id })
  }

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      paddingX="s24"
      paddingY="s16"
      border={{
        bottom: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
    >
      <Box gap="s24" flexDirection="row" alignItems="center">
        <PersonAvatar src={attachment} firstName={employeeName} lastName="" size="large" />
        <Text size="300" weight="medium">
          {employeeName}
        </Text>
      </Box>
      <Button.Router
        type="secondary"
        iconName="arrow-right"
        to={goToEmployee(employeeId)}
      ></Button.Router>
    </Box>
  )
}

export default EmployeeListItem
